<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Time to Choose</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><span href="#/text/ch005#the-medium" title="Link target outside of Sample">The Medium</span></li>
<li id="toc-li-6"><span href="#/text/ch006#the-neighbour-from-hell" title="Link target outside of Sample">The Neighbour from Hell</span></li>
<li id="toc-li-7"><span href="#/text/ch007#payback" title="Link target outside of Sample">Payback</span></li>
<li id="toc-li-8"><span href="#/text/ch008#ianthe" title="Link target outside of Sample">Ianthe</span></li>
<li id="toc-li-9"><span href="#/text/ch009#come-play-with-me" title="Link target outside of Sample">Come Play with Me</span></li>
<li id="toc-li-10"><span href="#/text/ch010#a-bouquet-of-roses" title="Link target outside of Sample">A Bouquet of Roses</span></li>
<li id="toc-li-11"><span href="#/text/ch011#night-stalker" title="Link target outside of Sample">Night Stalker</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7b7fdbc0